import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DFE8F9",
      d: "M24.01 8.49h-12.5a3 3 0 0 0-3 3v15.5a3 3 0 0 0 3 3h12.5a3 3 0 0 0 3-3v-15.5a3 3 0 0 0-3-3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "M24.51 9.74a2.25 2.25 0 0 0-2.25-2.25H9.76a2.25 2.25 0 0 0-2.25 2.25v15.5a2.25 2.25 0 0 0 2.25 2.25h12.5a2.25 2.25 0 0 0 2.25-2.25zm1.5 15.5a3.75 3.75 0 0 1-3.75 3.75H9.76a3.75 3.75 0 0 1-3.75-3.75V9.74a3.75 3.75 0 0 1 3.75-3.75h12.5a3.75 3.75 0 0 1 3.75 3.75z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "M9.01 6.74a3.746 3.746 0 0 1 3.75-3.75l.11.008a1 1 0 0 1 .107.024l10.63 3.22a.75.75 0 0 1-.435 1.436L12.664 4.494A2.244 2.244 0 0 0 10.51 6.74a.75.75 0 0 1-1.5 0M21.72 14.59c0-.247-.073-.484-.204-.687l-1.751 2.412 1.956 3.01zm-6.73 5.147 1.455 4.417c.098-.033.195-.073.285-.128l4.358-2.678q.146-.09.26-.21l-2.559-3.94zm-3.204 2.14 3.186 1.959-1.102-3.343zm.158-1.666 1.51-1.003-.491-1.58zm1.79-4.48.845 2.717 3.563-2.38-2.173-4.412zm5.35-.691 1.396-1.922-3.359-2.064zm-8.08-1.598 1.806 1.268 1.97-3.589zm-.713 6.808q.002.216.075.418l1.88-4.766-1.952-1.37q-.002.029-.003.058zm12.73 0c0 .907-.487 1.73-1.248 2.202l-.002.002-4.36 2.68a2.7 2.7 0 0 1-1.46.393h-.005a2.7 2.7 0 0 1-1.346-.393l-4.36-2.68-.002-.002A2.6 2.6 0 0 1 8.99 20.25v-5.66c0-.511.154-1.005.43-1.422q.01-.016.018-.031.012-.015.024-.028c.202-.287.464-.535.778-.723l4.36-2.68a2.69 2.69 0 0 1 2.811 0l4.36 2.68q.016.008.032.018l.008.007c.76.474 1.21 1.3 1.21 2.179z"
    }, null, -1)
  ]))]))
}
export default { render: render }